export const MAX_UPLOAD_FILES_PER_BATCH = 50;

export const limitFilesForUpload = (files) => {
  const selectedFiles = Array.from(files || []);

  if (selectedFiles.length <= MAX_UPLOAD_FILES_PER_BATCH) {
    return {
      files: selectedFiles,
      warning: null,
    };
  }

  return {
    files: [],
    warning: `Upload blocked. You can upload up to ${MAX_UPLOAD_FILES_PER_BATCH} files in one batch. Please select ${MAX_UPLOAD_FILES_PER_BATCH} files or fewer.`,
  };
};
